class SearchForm {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("searchForm", () => ({
                    // AlpineRender
                    typeResults: [],
                    agendaTags: [],

                    // Data
                    unixFormater: null,
                    formaterNoMonth: null,
                    formaterShortMonth: null,
                    formaterMonth: null,
                    formaterShortMonthYear: null,
                    formaterMonthYear: null,

                    async init() {
                        window.alpineRender(this);
                        this.initFormater();
                        this.initForm();
                    },

                    initFormater() {
                        this.unixFormater = new Intl.DateTimeFormat("fr-FR", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                        });

                        this.formaterNoMonth = new Intl.DateTimeFormat(
                            "fr-FR",
                            {
                                weekday: "long",
                                day: "numeric",
                            },
                        );

                        this.formaterMonth = new Intl.DateTimeFormat("fr-FR", {
                            weekday: "long",
                            day: "numeric",
                            month: "long",
                        });

                        this.formaterShortMonth = new Intl.DateTimeFormat(
                            "fr-FR",
                            {
                                weekday: "long",
                                day: "numeric",
                                month: "short",
                            },
                        );

                        this.formaterMonthYear = new Intl.DateTimeFormat(
                            "fr-FR",
                            {
                                weekday: "long",
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                            },
                        );

                        this.formaterShortMonthYear = new Intl.DateTimeFormat(
                            "fr-FR",
                            {
                                weekday: "long",
                                day: "numeric",
                                month: "short",
                                year: "numeric",
                            },
                        );
                    },
                    initForm() {
                        // Tags
                        if (
                            this.agendaTags.length !== this.params.tags.length
                        ) {
                            this.previousTypes = this.params.tags;
                        }
                        this.resetTags();

                        // Filtres
                        this.initPeriodLimit();
                        this.initPeriod();

                        const daysFromUrl = this.getDaysFromUrl();

                        if (
                            daysFromUrl.length === 2 &&
                            daysFromUrl.includes(0) &&
                            daysFromUrl.includes(6)
                        ) {
                            this.filter = this.WEEK_END;
                            this.previousFilter = this.filter;
                            return;
                        }

                        if (this.period.current) {
                            switch (this.period.current) {
                                case this.period.WEEKENDS:
                                    this.filter = this.WEEK_END;
                                    break;
                                case this.period.WEEKS:
                                    this.filter = this.NEXT_WEEK;
                                    break;
                                default:
                                    this.filter = this.MONTH;
                                    Object.keys(this.period.MONTHS).forEach(
                                        (idMonth) => {
                                            if (
                                                this.period.MONTHS[idMonth] ===
                                                this.period.current
                                            ) {
                                                this.month = idMonth;
                                            }
                                        },
                                    );
                                    break;
                            }
                        } else if (this.params.min && this.params.max) {
                            const startDate = new Date(this.params.min * 1000);
                            const endDate = new Date(this.params.max * 1000);

                            this.filter = this.PERIOD;
                            this.periodStart = this.formatUnix(startDate);
                            this.periodEnd = this.formatUnix(endDate);

                            this.previousPeriodStart = this.periodStart;
                            this.previousPeriodEnd = this.periodEnd;
                        } else {
                            this.filter = this.CURRENT;
                        }

                        this.previousFilter = this.filter;
                    },
                    initPeriodLimit() {
                        const date = new Date();
                        const end = new Date(
                            date.setMonth(date.getMonth() + 13),
                        );
                        this.periodEndMax = this.formatUnix(end);
                        const startMax = new Date(
                            end.setDate(end.getDate() - 1),
                        );
                        this.periodStartMax = this.formatUnix(startMax);
                    },
                    initPeriod() {
                        const date = new Date();
                        this.periodStartMin = this.formatUnix(date);
                        this.periodStart = this.periodStartMin;
                        this.previousPeriodStart = this.periodStart;
                        this.periodEnd = null;

                        const start = new Date(
                            date.setDate(date.getDate() + 1),
                        );
                        this.periodEndMin = this.formatUnix(start);

                        this.previousPeriodEnd = null;
                    },
                    onPeriodChange() {
                        if (!this.periodStart) {
                            return;
                        }

                        if (this.periodStart < this.periodStartMin) {
                            this.periodStart = this.periodStartMin;
                        } else if (this.periodStart > this.periodStartMax) {
                            this.periodStart = this.periodStartMax;
                        }

                        const periodStart = new Date(this.periodStart);
                        const minEnd = new Date(
                            periodStart.setDate(periodStart.getDate() + 1),
                        );
                        this.periodEndMin = this.formatUnix(minEnd);

                        if (!this.periodEnd) {
                            return;
                        }

                        if (this.periodEnd < this.periodEndMin) {
                            this.periodEnd = this.periodEndMin;
                        } else if (this.periodEnd > this.periodEndMax) {
                            this.periodEnd = this.periodEndMax;
                        }
                    },
                    getDaysFromUrl() {
                        const url = new URL(window.location.href);
                        const params = url.searchParams;

                        const days = [];

                        params.forEach((value, key) => {
                            const match = key.match(/^days\[(\d+)\]$/);
                            if (match) {
                                days.push(parseInt(value, 10));
                            }
                        });

                        return days.sort();
                    },
                    format(date, short = false) {
                        const dt = new Date(date);
                        let formatted;

                        if (short) {
                            formatted = this.formaterShortMonth.format(dt);
                        } else {
                            formatted = this.formaterMonth.format(dt);
                        }

                        if (dt.getDate() === 1) {
                            return formatted.replace("1", "1er");
                        }

                        return formatted;
                    },

                    getTitleDate(min, max, short = false) {
                        const currentDate = new Date(this.periodStartMin);

                        const minDate = new Date(min);
                        const maxDate = new Date(max);

                        const formatYear = short
                            ? this.formaterShortMonthYear
                            : this.formaterMonthYear;
                        const formatNoYear = short
                            ? this.formaterShortMonth
                            : this.formaterMonth;

                        const currentYear = currentDate.getFullYear();
                        const currentMon = currentDate.getMonth();

                        const minYear = minDate.getFullYear();
                        const maxYear = maxDate.getFullYear();
                        const minMon = minDate.getMonth();
                        const maxMon = maxDate.getMonth();

                        const nextYear = currentYear + 1;

                        if (minYear <= nextYear && maxYear <= nextYear) {
                            if (
                                (minYear === currentYear &&
                                    maxYear === currentYear) ||
                                maxMon < currentMon
                            ) {
                                if (minMon === maxMon) {
                                    return `Du ${this.formaterNoMonth.format(minDate)} au ${formatNoYear.format(maxDate)}`;
                                }
                                return `Du ${formatNoYear.format(minDate)} au ${formatNoYear.format(maxDate)}`;
                            }
                        }
                        return `Du ${formatYear.format(minDate)} au ${formatYear.format(maxDate)}`;
                    },

                    formatUnix(date) {
                        const dateParts = this.unixFormater
                            .formatToParts(date)
                            .reduce(
                                (output, element) => (
                                    (output[element.type] = element.value),
                                    output
                                ),
                                {},
                            );
                        return `${dateParts.year}-${dateParts.month}-${dateParts.day}`;
                    },

                    // Type
                    selectAll() {
                        this.typeResults.forEach((type) => {
                            type.checked = false;
                            type.children.forEach((children) => {
                                children.checked = false;
                            });
                        });

                        this.previousTypes = [];

                        const dialog = document.querySelector(
                            "dialog[x-ref='dialogType']",
                        );
                        if (dialog?.open) {
                            dialog.close();
                        }
                    },
                    onTypeChange(type) {
                        type.children.forEach((children) => {
                            children.checked = type.checked;
                        });
                    },

                    onTagChange(type) {
                        const nbrChecked = type.children.filter(
                            (children) => children.checked,
                        ).length;

                        type.checked = !!nbrChecked;

                        const typeCheckbox = document.querySelector(
                            `dialog[x-ref='dialogType'] input[type='checkbox'][data-type='${type.value}']`,
                        );

                        if (typeCheckbox) {
                            typeCheckbox.indeterminate =
                                type.checked &&
                                nbrChecked !== type.children.length;
                        }
                    },

                    get labelFromType() {
                        let label = null;

                        let nbrCheckedTags = 0;
                        let nbrTags = 0;

                        this.typeResults.forEach((type) => {
                            const checkedTags = type.children.filter(
                                (tag) => tag.checked,
                            );
                            nbrTags += type.children.length;
                            nbrCheckedTags += checkedTags.length;

                            if (checkedTags.length) {
                                if (
                                    nbrCheckedTags !== checkedTags.length ||
                                    (checkedTags.length > 1 &&
                                        checkedTags.length !==
                                            type.children.length)
                                ) {
                                    label = `${nbrCheckedTags} types d'évènements`;
                                } else if (checkedTags.length === 1) {
                                    label = checkedTags[0].label;
                                } else if (
                                    checkedTags.length === type.children.length
                                ) {
                                    label = type.label;
                                }
                            }
                        });

                        if (
                            nbrCheckedTags === 0 ||
                            nbrCheckedTags === nbrTags
                        ) {
                            label = "Tous les types";
                        }
                        return label;
                    },

                    // Filters
                    resetFilter() {
                        this.filter = this.previousFilter;
                        this.month = this.previousMonth;
                        this.periodStart = this.previousPeriodStart;
                        this.periodEnd = this.previousPeriodEnd;

                        this.onPeriodChange();
                    },
                    onSubmitMonth(element) {
                        if (element.ariaDisabled === "true") {
                            return;
                        }
                        this.previousFilter = this.filter;
                        this.previousMonth = this.month;

                        this.initPeriod();

                        const dialog = document.querySelector(
                            "dialog[x-ref='dialogMonth']",
                        );
                        if (dialog?.open) {
                            dialog.close();
                        }
                    },
                    onSubmitPeriod(element) {
                        if (element.ariaDisabled === "true") {
                            return;
                        }
                        this.previousFilter = this.filter;
                        this.previousPeriodStart = this.periodStart;
                        this.previousPeriodEnd = this.periodEnd;

                        this.resetMonth();

                        const dialog = document.querySelector(
                            "dialog[x-ref='dialogPeriod']",
                        );
                        if (dialog?.open) {
                            dialog.close();
                        }
                    },
                    resetMonth() {
                        this.previousMonth = null;
                        this.month = null;
                    },
                    resetTags() {
                        this.typeResults.forEach((type) => {
                            type.children.forEach((tag) => {
                                tag.checked = this.previousTypes.some(
                                    (id) => id === tag.value,
                                );
                            });
                            this.onTagChange(type);
                        });
                    },
                    onSubmitTags(element) {
                        if (element.ariaDisabled === "true") {
                            return;
                        }
                        this.previousTypes = [];

                        this.typeResults.forEach((type) => {
                            type.children.forEach((tag) => {
                                if (tag.checked) {
                                    this.previousTypes.push(tag.value);
                                }
                            });
                        });

                        const dialog = document.querySelector(
                            "dialog[x-ref='dialogType']",
                        );
                        if (dialog?.open) {
                            dialog.close();
                        }
                    },
                }));
            },
            { once: true },
        );
    }
}

new SearchForm();
